module.exports = __webpack_public_path__ + "static/img/logo.6a27fa0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo.png
// module id = Z2Ou
// module chunks = 1